module.exports = {
  config: {
    isDemo: false,
    prodAppServerHost: '',
    prodAppServerPort: 3000,
    devApiProtocol: 'http',
    prodApiProtocol: 'https',
    devApiHost: 'localhost:8080',
    prodApiHost: 'cmsapi.europe.wegoshare.com',
  },
}


//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = 804
// module chunks = 0